<script setup>
import { ref } from 'vue'

const props = defineProps({
  text: {
    type: String,
  },
  position: {
    type: String,
    default: 'right',
  },
})

const tooltipDirection = ref(props.position)

switch (props.position) {
  case 'right':
    tooltipDirection.value = 'absolute left-[110%] w-[150px] z-10 bg-gray-900 text-white p-2 rounded-md font-normal justify-left text-sm'
    break
  case 'left':
    tooltipDirection.value = 'absolute w-[200px] right-[110%] z-10 bg-gray-900 text-white p-2 rounded-md font-normal justify-left text-sm'
    break
}
</script>

<template>
  <div :class="tooltipDirection">
    {{ props.text }}
  </div>
</template>

<style scoped></style>
